import { tokens } from '@fluentui/react-theme';
import { __styles, mergeClasses, shorthands } from '@griffel/react';
import { createCustomFocusIndicatorStyle } from '@fluentui/react-tabster';
// eslint-disable-next-line deprecation/deprecation
export const alertClassNames = {
  root: 'fui-Alert',
  icon: 'fui-Alert__icon',
  action: 'fui-Alert__action',
  avatar: 'fui-Alert__avatar'
};
const useStyles = /*#__PURE__*/__styles({
  root: {
    mc9l5x: "f22iagw",
    Bt984gj: "f122n59",
    sshi5w: "f5pgtk9",
    z8tnut: "f1g0x7ka",
    z189sj: ["f11qrl6u", "fjlbh76"],
    Byoj8tv: "f1qch9an",
    uwmqm3: ["fjlbh76", "f11qrl6u"],
    Bbmb7ep: ["fff7au0", "f1bjk9e1"],
    Beyfa6y: ["f1bjk9e1", "fff7au0"],
    B7oj6ja: ["fwsfkhu", "f8wkphi"],
    Btl43ni: ["f8wkphi", "fwsfkhu"],
    B4j52fo: "f5ogflp",
    Bekrc4i: ["f1hqa2wf", "finvdd3"],
    Bn0qgzm: "f1f09k3d",
    ibv6hh: ["finvdd3", "f1hqa2wf"],
    icvyot: "fzkkow9",
    vrafjx: ["fcdblym", "fjik90z"],
    oivjwe: "fg706s2",
    wvpqe5: ["fjik90z", "fcdblym"],
    g2u3we: "fghlq4f",
    h3c5rm: ["f1gn591s", "fjscplz"],
    B9xav0g: "fb073pr",
    zhjwy3: ["fjscplz", "f1gn591s"],
    E5pizo: "fz58gqq",
    Be2twd7: "fkhj508",
    Bhrd7zp: "fl43uef",
    sj55zd: "f19n0e5",
    De3pzq: "fxugw4r"
  },
  inverted: {
    sj55zd: "f1w7i9ko",
    De3pzq: "f5pduvr"
  },
  icon: {
    Bqenvij: "fd461yt",
    Be2twd7: "f4ybsrx",
    z8tnut: "f1g0x7ka",
    z189sj: ["f19lj068", "f177v4lu"],
    Byoj8tv: "f1qch9an",
    uwmqm3: ["f1cnd47f", "fhxju0i"]
  },
  avatar: {
    B6of3ja: "f1hu3pq6",
    t21cq0: ["f1phki43", "ff9s3yw"],
    jrapky: "f19f4twv",
    Frg6f3: ["f1tyq0we", "f11qmguv"]
  },
  action: {
    z8tnut: "f1sbtcvk",
    z189sj: ["f81rol6", "frdkuqy"],
    Byoj8tv: "fdghr9",
    uwmqm3: ["frdkuqy", "f81rol6"],
    Bf4jedk: "fy77jfu",
    Frg6f3: ["fcgxt0o", "f1ujusj6"],
    sj55zd: "f16muhyy"
  }
}, {
  d: [".f22iagw{display:flex;}", ".f122n59{align-items:center;}", ".f5pgtk9{min-height:44px;}", ".f1g0x7ka{padding-top:0;}", ".f11qrl6u{padding-right:12px;}", ".fjlbh76{padding-left:12px;}", ".f1qch9an{padding-bottom:0;}", ".fff7au0{border-bottom-right-radius:4px;}", ".f1bjk9e1{border-bottom-left-radius:4px;}", ".fwsfkhu{border-top-right-radius:4px;}", ".f8wkphi{border-top-left-radius:4px;}", ".f5ogflp{border-top-width:1px;}", ".f1hqa2wf{border-right-width:1px;}", ".finvdd3{border-left-width:1px;}", ".f1f09k3d{border-bottom-width:1px;}", ".fzkkow9{border-top-style:solid;}", ".fcdblym{border-right-style:solid;}", ".fjik90z{border-left-style:solid;}", ".fg706s2{border-bottom-style:solid;}", ".fghlq4f{border-top-color:var(--colorTransparentStroke);}", ".f1gn591s{border-right-color:var(--colorTransparentStroke);}", ".fjscplz{border-left-color:var(--colorTransparentStroke);}", ".fb073pr{border-bottom-color:var(--colorTransparentStroke);}", ".fz58gqq{box-shadow:var(--shadow8);}", ".fkhj508{font-size:var(--fontSizeBase300);}", ".fl43uef{font-weight:var(--fontWeightSemibold);}", ".f19n0e5{color:var(--colorNeutralForeground1);}", ".fxugw4r{background-color:var(--colorNeutralBackground1);}", ".f1w7i9ko{color:var(--colorNeutralForegroundInverted2);}", ".f5pduvr{background-color:var(--colorNeutralBackgroundInverted);}", ".fd461yt{height:16px;}", ".f4ybsrx{font-size:16px;}", ".f19lj068{padding-right:8px;}", ".f177v4lu{padding-left:8px;}", ".f1cnd47f{padding-left:0;}", ".fhxju0i{padding-right:0;}", ".f1hu3pq6{margin-top:0;}", ".f1phki43{margin-right:8px;}", ".ff9s3yw{margin-left:8px;}", ".f19f4twv{margin-bottom:0;}", ".f1tyq0we{margin-left:0;}", ".f11qmguv{margin-right:0;}", ".f1sbtcvk{padding-top:5px;}", ".f81rol6{padding-right:10px;}", ".frdkuqy{padding-left:10px;}", ".fdghr9{padding-bottom:5px;}", ".fy77jfu{min-width:0;}", ".fcgxt0o{margin-left:auto;}", ".f1ujusj6{margin-right:auto;}", ".f16muhyy{color:var(--colorBrandForeground1);}"]
});
const useIntentIconStyles = /*#__PURE__*/__styles({
  success: {
    sj55zd: "f1m7fhi8"
  },
  error: {
    sj55zd: "f1whyuy6"
  },
  warning: {
    sj55zd: "fpti2h4"
  },
  info: {
    sj55zd: "fkfq4zb"
  }
}, {
  d: [".f1m7fhi8{color:var(--colorPaletteGreenForeground3);}", ".f1whyuy6{color:var(--colorPaletteRedForeground3);}", ".fpti2h4{color:var(--colorPaletteYellowForeground2);}", ".fkfq4zb{color:var(--colorNeutralForeground2);}"]
});
const useIntentIconStylesInverted = /*#__PURE__*/__styles({
  success: {
    sj55zd: "f1pvjcpr"
  },
  error: {
    sj55zd: "fcrp5ll"
  },
  warning: {
    sj55zd: "f1r8f1cl"
  },
  info: {
    sj55zd: "f1w7i9ko"
  }
}, {
  d: [".f1pvjcpr{color:var(--colorPaletteGreenForegroundInverted);}", ".fcrp5ll{color:var(--colorPaletteRedForegroundInverted);}", ".f1r8f1cl{color:var(--colorPaletteYellowForegroundInverted);}", ".f1w7i9ko{color:var(--colorNeutralForegroundInverted2);}"]
});
const useActionButtonColorInverted = /*#__PURE__*/__styles({
  action: {
    sj55zd: "f1qz2gb0",
    B8q5s1w: "fa5e339",
    Bci5o5g: ["fk4svks", "fqzoz0o"],
    n8qw10: "fw8q0i0",
    Bdrgwmp: ["fqzoz0o", "fk4svks"],
    Bfpq7zp: "f1dlk4fq"
  }
}, {
  d: [".f1qz2gb0{color:var(--colorBrandForegroundInverted);}", ".fa5e339[data-fui-focus-visible]{border-top-color:var(--colorTransparentStrokeInteractive);}", ".fk4svks[data-fui-focus-visible]{border-right-color:var(--colorTransparentStrokeInteractive);}", ".fqzoz0o[data-fui-focus-visible]{border-left-color:var(--colorTransparentStrokeInteractive);}", ".fw8q0i0[data-fui-focus-visible]{border-bottom-color:var(--colorTransparentStrokeInteractive);}", ".f1dlk4fq[data-fui-focus-visible]{outline-color:var(--colorNeutralBackground5Pressed);}"]
});
/**
 * @deprecated please use the Toast or MessageBar component
 * Apply styling to the Alert slots based on the state
 */ // eslint-disable-next-line deprecation/deprecation
export const useAlertStyles_unstable = state => {
  const inverted = state.appearance === 'inverted';
  const styles = useStyles();
  const intentIconStylesPrimary = useIntentIconStyles();
  const intentIconStylesInverted = useIntentIconStylesInverted();
  const actionStylesInverted = useActionButtonColorInverted();
  state.root.className = mergeClasses(alertClassNames.root, styles.root, inverted && styles.inverted, state.root.className);
  if (state.icon) {
    state.icon.className = mergeClasses(alertClassNames.icon, styles.icon, state.intent && (inverted ? intentIconStylesInverted[state.intent] : intentIconStylesPrimary[state.intent]), state.icon.className);
  }
  if (state.avatar) {
    state.avatar.className = mergeClasses(alertClassNames.avatar, styles.avatar, state.avatar.className);
  }
  if (state.action) {
    // Note: inverted && actionStylesInverted.action has the highest piority and must be merged last
    state.action.className = mergeClasses(alertClassNames.action, styles.action, inverted && actionStylesInverted.action, state.action.className);
  }
  return state;
};
//# sourceMappingURL=useAlertStyles.styles.js.map